/**
 * CloudSimulatorCard — Cloud 5.0 Escalation Simulator configuration + results display.
 *
 * Renders Duration number input and Time of Day time input in a 2-column grid,
 * a Simulate Careflow button, plus a scrollable simulation results table.
 *
 * Note: Event Category is NOT here (it's in CloudDeviceSelectionCard since it
 * affects the alarm payload). The simulator uses the event_category_id selected there.
 *
 * All state is owned by the parent CloudDemoPage — this component receives
 * everything via props and calls onChange handlers for updates.
 */

import { convertIsoToLocalTime } from '../../../libs.jsx';

const CloudSimulatorCard = ({
    duration,
    onDurationChange,
    timeOfDay,
    onTimeOfDayChange,
    onSimulate,
    canSubmit,
    simulateData,
    loadingSimulate,
}) => {
    return (
        <div className="dm-card">
            <h3 className="dm-card__header">Escalation Simulator</h3>
            <div className="dm-card__body">
                {/* Config inputs — 2-column grid */}
                <div className="dm-sim-config--2col">
                    <div>
                        <label htmlFor="dmc-sim-duration" className="dm-field__label">Duration (Min)</label>
                        <input
                            type="number"
                            id="dmc-sim-duration"
                            className="dm-field__input"
                            value={duration}
                            min={1}
                            max={60}
                            step={1}
                            onChange={(e) => onDurationChange(parseInt(e.target.value, 10) || 30)}
                        />
                    </div>
                    <div>
                        <label htmlFor="dmc-sim-time" className="dm-field__label">Time of Day</label>
                        <input
                            type="time"
                            id="dmc-sim-time"
                            className="dm-field__input"
                            value={timeOfDay}
                            onChange={(e) => onTimeOfDayChange(e.target.value)}
                        />
                    </div>
                </div>

                {/* Simulate button */}
                <div className="dm-actions">
                    <button
                        className="rp-btn rp-btn--primary"
                        onClick={onSimulate}
                        disabled={!canSubmit || loadingSimulate}
                    >
                        {loadingSimulate ? <><span className="dm-spinner" />Calculating...</> : 'Simulate Careflow'}
                    </button>
                </div>

                {/* Results table */}
                <div className="dm-sim-results">
                    {loadingSimulate ? (
                        <div className="dm-sim-empty">
                            <span className="dm-spinner" />Simulating...
                        </div>
                    ) : simulateData.length === 0 ? (
                        <div className="dm-sim-empty">
                            Select a device and click "Simulate Careflow" to run
                        </div>
                    ) : (
                        <table className="dm-sim-table">
                            <thead>
                                <tr>
                                    <th>Event Time</th>
                                    <th>Event Action</th>
                                    <th>To</th>
                                </tr>
                            </thead>
                            <tbody>
                                {simulateData.map((row, idx) => (
                                    <tr key={idx}>
                                        <td style={{ minWidth: 100 }}>{convertIsoToLocalTime(row.timestamp)}</td>
                                        <td style={{ minWidth: 175 }}>{row.handler}</td>
                                        <td style={{ minWidth: 100 }}>
                                            {Array.isArray(row.to)
                                                ? row.to.map((item, i) => (
                                                    <span key={i}>{i > 0 ? <br /> : null}{item}</span>
                                                ))
                                                : row.to
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CloudSimulatorCard;
